import { render } from "./RiskIndicatorData.vue?vue&type=template&id=1408a1b9"
import script from "./RiskIndicatorData.vue?vue&type=script&lang=js"
export * from "./RiskIndicatorData.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__